<template>
  <FormLayout>
    <TextField
      :label="$t('common.Name')"
      :help-text="$t('common.uniqueNameMessage')"
      :disabled="readonly"
      v-model="node.name"
    />
  </FormLayout>
</template>

<script>
export default {
  inject: ['$t'],
  props: {
    node: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean
    }
  }
}
</script>
